import ExcelJS from "exceljs";
import downloadExcel from "@/views/Reports/downloadExcel";

class CreateAgeGroupWorkbook {
  async createExcel(listData, fields, fileName) {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Report");

    sheet.columns = fields.map((f) => ({
      header: f.header,
      key: f.key,
      width: 20,
    }));

    listData.forEach((row) => {
      const data = {};
      fields.forEach((f) => {
        data[f.key] = row[f.key];
      });
      sheet.addRow(data);
    });

    fields.forEach((f) => {
      const col = sheet.getColumn(f.key);

      switch (f.format) {
        case "integer":
          col.numFmt = "#,##0";
          break;
        case "number":
          col.numFmt = "#,##0.00";
          break;
        case "currency":
          col.numFmt = "#,##0.00";
          break;
        case "percent":
          col.numFmt = "0.00%";
          break;
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    downloadExcel.downloadFile(buffer, fileName);
  }
}

export default new CreateAgeGroupWorkbook();
